import { TRAINING_EXTENDED_LESSON_IDS } from "../activation/activationPath";
import { useTrainingMode } from "./TrainingModeContext";
import { Link } from "react-router-dom";
import s from "./training.module.css";

export default function TrainingFullTourBanner({ onDismiss }) {
  const {
    startExtendedTraining,
    startFullTraining,
    active: trainingActive,
  } = useTrainingMode();

  if (trainingActive) return null;

  return (
    <div className={s.fullTourBanner} role="status">
      <div className={s.fullTourBannerGlow} aria-hidden />
      <div className={s.fullTourBannerMain}>
        <p className={s.fullTourBannerKicker}>Основы готовы</p>
        <h3 className={s.fullTourBannerTitle}>Что дальше?</h3>
        <p className={s.fullTourBannerText}>
          Полное обучение — ещё {TRAINING_EXTENDED_LESSON_IDS.length} разделов
          (~10 мин). Или откройте базу знаний с пошаговыми инструкциями.
        </p>
      </div>
      <div className={s.fullTourBannerActions}>
        <button
          type="button"
          className={s.fullTourBannerPrimary}
          onClick={() =>
            (startExtendedTraining || startFullTraining)?.({ reset: true })
          }
        >
          Полное обучение
        </button>
        <Link to="/manage/app/help" className={s.fullTourBannerGhostLink}>
          База знаний
        </Link>
        <button
          type="button"
          className={s.fullTourBannerGhost}
          onClick={onDismiss}
        >
          Не сейчас
        </button>
      </div>
    </div>
  );
}
